































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { trim, dateFormat } from "@/util";
import Api from "../../../api/index";
import request from "../../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import { SzgcProcessGetor, SzgcMobileGetor } from "@/index";

@Component({
  name: "WbenchTosend",
  components: {
    SzgcProcessGetor,
    SzgcMobileGetor
  }
})
export default class WbenchTosend extends Vue {
  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private topShow!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessName: any = "";
  private total: number = 0;
  private params: any = {
    current: 1,
    pageSize: 20
  };
  private tableData: any = [];
  private modalShow: boolean = false;
  private modalTitle: string = "流程修改";
  private flowInfo: any = {};
  private prefix: string = "";

  mounted() {
    this.prefix = getCookie("plt-api-route") || "";
    this.getTableData();
  }

  /*获取表格数据*/
  async getTableData() {
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getToSendPages,
        method: "post",
        data: {
          clientType: "web",
          businessName: trim(this.businessName),
          current: this.params.current,
          pageSize: this.params.pageSize
        }
      });
      if (!success) {
        this.$message.error("获取待发事项列表失败:" + message);
        return false;
      }
      const temp: any = [];
      if (data && data.records && data.records.length > 0) {
        data.records.map((item: any) => {
          item.createTime = dateFormat(item.createTime);
          temp.push(item);
        });
        this.total = data.total;
      }
      this.tableData = temp;
      this.$emit("getTotal");
    } catch (error: any) {
      this.$message.error("获取待发事项列表失败:" + error);
    }
  }

  /*待发流程删除*/
  async flowDel(row: any) {
    let confirm;
    try {
      confirm = await this.$confirm(`确认删除待发流程?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning"
      });
    } catch (e) {
      confirm = null;
    }
    if (!confirm) {
      return false;
    }
    try {
      const { success, message } = await request({
        url: this.prefix + Api.delSendNotForm(),
        method: "delete",
        data: {
          businessId: row.businessId
        }
      });
      if (!success) {
        this.$message.error("流程删除失败:" + message);
        return false;
      }
      this.$message.success("流程删除成功");
      await this.getTableData();
    } catch (error: any) {
      this.$message.error("流程删除失败:" + error);
    }
  }

  /*流程弹窗*/
  async showModal(data: any) {
    if (!data.dialogEnable) {
      return this.$message.info("请在APP端查看和操作该事项");
    }
    this.flowInfo = {
      businessId: data.businessId
    };
    this.modalShow = true;
  }

  /*关闭弹窗*/
  async dealSuccess() {
    this.modalShow = false;
    await this.getTableData();
  }

  /*搜索*/
  searchEvt() {
    this.params.current = 1;
    this.params.businessId = "";
    this.getTableData();
  }

  /*页数改变*/
  onCurrentChange(val: any) {
    this.params.current = val;
    this.getTableData();
  }

  /*size改变*/
  onSizeChange(val: any) {
    this.params.current = 1;
    this.params.pageSize = val;
    this.getTableData();
  }
}
